<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-content">
      <div class="tuolele-main-search">
        <el-button type="success" @click="popUpdateAward()">添加奖品</el-button>
      </div>
      <el-table :key="'award'+dialogAwardKey" :data="awardLists" border>
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="goods_name" label="奖品名称" />
        <el-table-column prop="title" label="图片">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.goods_pic" fit="fill" />
          </template>
        </el-table-column>
        <el-table-column prop="probability" label="概率" />
        <el-table-column prop="stock" label="奖品数" />
        <el-table-column prop="level" label="奖品等级">
          <template slot-scope="scope">
            {{ levels[scope.row.level] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="popUpdateAward(scope.row)">编辑</el-button>
            <el-button type="error" size="mini" @click="fnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :key="'create'+dialogKey" title="新增活动" :visible.sync="dialogVisible" width="600px">
        <el-form ref="postForm" :model="postForm" :rules="rules">
          <el-form-item label="奖品名称" prop="goods_name">
            <el-input v-model="postForm.goods_name" style="width: 400px;" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="中奖概率" prop="probability">
            <el-input-number v-model="postForm.probability" :min="1" :max="100" label="描述文字" />
          </el-form-item>
          <el-form-item label="库存" prop="stock">
            <el-input-number v-model="postForm.stock" :min="0" label="描述文字" />
          </el-form-item>
          <el-form-item label="奖品等级" prop="level">
            <el-select v-model="postForm.level" placeholder="请选择">
              <el-option v-for="(value,key) in levels" :key="key" :value="key" :label="value" />
            </el-select>
          </el-form-item>
          <el-form-item label="奖品图片" prop="goods_pic">
            <UploadImg
              :photo.sync="postForm.goods_pic"
              :name="'goods_pic'"
              @updateImg="updatePhoto"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="fnSubmit">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>

const defaultPostForm = {
  id: '',
  lottery_id: '',
  goods_name: '',
  goods_pic: '',
  probability: '',
  stock: '',
  level: ''
}

import { validateRequire } from '@/utils/validate'
import UploadImg from '@/components/toolbar/UploadImg.vue'
import commondata from '@/utils/commondata'

export default {
  name: 'ActiveAwardLists',
  components: {
    UploadImg
  },
  data() {
    return {
      listQuery: {
        lottery_id: ''
      },
      dialogKey: 0,
      dialogAwardKey: 0,
      postForm: Object.assign({}, defaultPostForm),
      dialogVisible: false,
      awardLists: [],
      rules: {
        goods_name: [{ validator: validateRequire, trigger: 'manual', message: '奖品名称' }],
        probability: [{ validator: validateRequire, trigger: 'manual', message: '获奖概率' }],
        goods_pic: [{ validator: validateRequire, trigger: 'manual', message: '奖品图片' }],
        stock: [{ validator: validateRequire, trigger: 'manual', message: '奖品数' }],
        level: [{ validator: validateRequire, trigger: 'manual', message: '奖品等级' }]
      },
      levels: commondata.LUCKY_LEVEL_MAP
    }
  },
  mounted() {
    this.listQuery.lottery_id = this.$route.query.id
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.$http.getLuckyGoodsList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count || 0)
        this.awardLists = res.data.list
      })
    },
    updatePhoto: function(photo, name) {
      this.$set(this.postForm, name, photo)
    },
    popUpdateAward(award) {
      if (!award) {
        this.postForm = Object.assign({}, defaultPostForm)
        this.postForm.lottery_id = this.listQuery.lottery_id
        this.dialogVisible = true
        return
      }
      this.postForm = Object.assign({}, award)
      this.postForm.lottery_id = this.listQuery.lottery_id
      this.dialogVisible = true
    },
    fnDelete(id) {
      this.$confirm('此操作将永久删除该奖品， 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteLuckyAcitveGoods({ id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.fnGetLists()
          }
        })
      }).catch(() => {

      })
    },
    fnSubmit() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.improveAcitveGoods(this.postForm).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.dialogVisible = false
              this.fnGetLists()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
